export const isValidFileUploaded = (file: File) => {
	const validExtensions: string[] = ['png', 'jpeg', 'jpg', 'pdf'];
	const fileExtension: string = file.type.split('/')[1];
	return validExtensions.includes(fileExtension);
};
